__turbopack_context__.v({
  "badgeTitle": "index-module__ONQOTa__badgeTitle",
  "badgeTitleSmall": "index-module__ONQOTa__badgeTitleSmall",
  "carouselSlide": "index-module__ONQOTa__carouselSlide",
  "contentDescription": "index-module__ONQOTa__contentDescription",
  "gallerySlide": "index-module__ONQOTa__gallerySlide",
  "highlightSlide": "index-module__ONQOTa__highlightSlide",
  "iescSlide": "index-module__ONQOTa__iescSlide",
  "introBadgeGrid": "index-module__ONQOTa__introBadgeGrid",
  "introSlide": "index-module__ONQOTa__introSlide",
  "introSlideThree": "index-module__ONQOTa__introSlideThree",
  "mixerDescription": "index-module__ONQOTa__mixerDescription",
  "mixerItemGrid": "index-module__ONQOTa__mixerItemGrid",
  "slideMaxXs": "index-module__ONQOTa__slideMaxXs",
});
